<template>
  <!--==== NEWS ====-->
  <div :class="['news_center', language === 'cn' ? 'font-cn' : 'font-en']">
    <div class="page_header">
      <h1>{{ content.news_title }}</h1>
    </div>
    <div class="main-content">
      <div
        v-for="news in content.topNews"
        :key="news.id"
        @click="newsDetail(news.DetailPageName)"
      >
        <div v-if="CurrentPage === 1" class="top-news">
          <img :src="news.image" alt="Top News" />
          <div class="top-news-text">
            <h2>{{ news.title }}</h2>
            <p>{{ news.description }}</p>
          </div>
        </div>
      </div>
      <div class="news-list">
        <div
          class="news-item"
          v-for="news in paginatedNewsItems"
          :key="news.id"
          @click="newsDetail(news.DetailPageName)"
        >
          <img :src="news.image" alt="News Image" />
          <div class="news-text">
            <h3>{{ news.title }}</h3>
            <p>{{ news.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <button @click="previousPage" :disabled="CurrentPage === 1">
        Previous
      </button>
      <button
        v-for="page in totalPages"
        :key="page"
        @click="goToPage(page)"
        :class="{ active: page === CurrentPage }"
      >
        {{ page }}
      </button>
      <button @click="nextPage" :disabled="CurrentPage === totalPages">
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import en from "@/data/news_en.js";
import cn from "@/data/news_cn.js";

export default {
  name: "AppNews",
  mixins: [en, cn],
  data() {
    return {
      CurrentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
    newsItems() {
      return this.content.newsItems || [];
    },
    sortedNewsItems() {
      return [...this.newsItems].sort((a, b) => b.id - a.id); // Sorts newsItems in descending order
    },
    totalPages() {
      return Math.ceil(this.newsItems.length / this.itemsPerPage);
    },
    paginatedNewsItems() {
      const start = (this.CurrentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.sortedNewsItems.slice(start, end);
    },
  },
  methods: {
    nextPage() {
      if (this.CurrentPage < this.totalPages) {
        this.CurrentPage++;
      }
    },
    previousPage() {
      if (this.CurrentPage > 1) {
        this.CurrentPage--;
      }
    },
    goToPage(page) {
      this.CurrentPage = page;
    },
    newsDetail(DetailPageName) {
      this.$router.push(`/news/${DetailPageName}`);
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); 
    },
  },
};
</script>
<style scoped>
/* NEWS */

.news-center {
  font-family: Arial, sans-serif;
}

/* page header uses global .page_header */

.header h1 {
  margin: 0;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.top-news {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.top-news:hover {
  box-shadow: 0 0 10px rgb(255, 0, 0); 
}

.top-news img {
  max-width: 100%; 
  height: auto; 
  object-fit: cover; 
  margin-right: 20px;
}

.top-news-text {
  flex: 1;
}

.top-news-text h2 {
  margin-top: 0;
}

/* Responsive height for other news sectors */
.news-list {
  display: flex;
  flex-direction: column;
}

.news-item {
  display: flex;
  margin-bottom: 20px;
  min-height: 150px; /* Minimum height for each news item */
  border-bottom: 1px solid #ccc;
  overflow: hidden; /* Prevents content from overflowing */
}

.news-item:hover {
  box-shadow: 0 0 10px rgb(255, 0, 0); /* Shadow effect */
}

.news-item img {
  max-width: 200px; /* Maintain a fixed max-width */
  height: 150px; /* Maintain aspect ratio */
  object-fit: cover; /* Ensure image covers the container without distortion */
  margin-right: 20px;
}

.news-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center the text vertically */
  padding: 10px; /* Add padding for better spacing */
}

.news-text h3 {
  margin-top: 0;
}

/* Media queries for responsiveness */
@media (max-width: 1200px) {
  .top-news img {
    max-width: 60%; /* Ensure image scales with container */
    height: auto; /* Maintain aspect ratio */
    object-fit: cover; /* Cover the container area without distortion */
    margin-right: 20px;
  }
}

@media (max-width: 768px) {
  .news-item {
    min-height: 200px; /* Increase min-height on smaller screens */
  }
  .top-news img {
    max-width: 50%; /* Ensure image scales with container */
    height: auto; /* Maintain aspect ratio */
    object-fit: cover; /* Cover the container area without distortion */
    margin-right: 20px;
  }
  .news-item img {
    max-width: 120px; /* Adjust image size for smaller screens */
    margin-right: 10px; /* Reduce margin */
  }
}

.pagination {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.pagination button {
  margin: 0 5px;
  padding: 10px 20px;
  cursor: pointer;
}

.pagination button.active {
  background-color: #ff0000;
  color: white;
  border: none;
}
</style>

